import { atomWithReset } from 'jotai/utils';
import { atom } from 'jotai';
import { StepInstructionWriting } from '@/types';
import { IeltsDetailAnswerInput, IeltsWritingCheckpointQuery } from '@/__generated__/graphql';

export const writingStepInstructionAtom = atomWithReset<StepInstructionWriting>(
  StepInstructionWriting.PreviewCheckPoint,
);

export const writingCheckPointAtom = atomWithReset<
  IeltsWritingCheckpointQuery['checkPoint'] | undefined
>(undefined);

export const currentPartIdAtom = atomWithReset<string | undefined>(undefined);

export const ieltsWritingCurrentPartAtom = atom((get) => {
  const checkPoint = get(writingCheckPointAtom);
  const currentPartId = get(currentPartIdAtom);
  const currentPart = checkPoint?.checkPointIeltsWritingParts.find(
    (part) => part.node.id === currentPartId,
  );
  return currentPart;
});

export const isCurrentPracticeIeltsPartAtom = atom((get) => {
  const currentPart = get(ieltsWritingCurrentPartAtom);
  const isPractice = (currentPart?.node.ieltsWritingPartQuestions || []).length > 0;
  return isPractice;
});

export const ieltsWritingSelectedPartsAtom = atomWithReset<
  NonNullable<IeltsWritingCheckpointQuery['checkPoint']>['checkPointIeltsWritingParts']
>([]);

export const isIeltsPracticeAtom = atom((get) => {
  const writingCheckpoint = get(writingCheckPointAtom);
  return writingCheckpoint?.type === 'IELTS_PRACTICE';
});

export const writingSubmitAttemptCallbackAtom = atomWithReset<(() => Promise<void>) | undefined>(
  undefined,
);
